import { useEffect, useState } from "react";
import Flag from "react-world-flags";
import { CloseIcon, CheckIcon, DropdownIcon } from "@components/Icon";
import styles from "./styles/Inputs.module.css";

const PhoneNumber = ({ value, onChange }) => {
  return (
    <input
      className={styles.phone}
      id="phone"
      type="tel"
      name="phone"
      placeholder="Phone Number"
      value={value}
      onChange={onChange}
    />
  )
}

export const PhoneInput = ({
  value,
  onChange,
  onChangeCountry,
  countryCode,
  options,
  error,
  errorMsg
}) => {
  const [showCountries, setShowCountries] = useState(false);
  const [dialCode, setDialCode] = useState("+1");

  useEffect(() => {
    const selected = options.find(option => option.code === countryCode);
    setDialCode(selected.value);
  }, [countryCode]);

  const toggleCountries = (e) => {
    e.preventDefault();
    setShowCountries(!showCountries)
  };

  const selectCountry = (e, code) => {
    e.preventDefault();
    onChangeCountry(code);
    setShowCountries(false);
  }

  const Header = () => {
    return (
      <header className={styles.countriesHeader}>
        <h3>Select a country</h3>
        <button onClick={() => setShowCountries(false)} aria-label="Close">
          <CloseIcon />
        </button>
      </header>
    )
  }

  const Dropdown = () => {
    return (
      <section className={styles.countries}>
        <Header />
        <ul>
          {options.map(option => {
            return (
              <li key={option.code} className={styles.listItem}>
                <button
                  className={styles.listItemButton}
                  onClick={(e) => selectCountry(e, option.code)}
                  aria-label="Select country"
                >
                  <Flag code={option.code} />
                  <p>{`${option.name} (${option.value})`}</p>
                  {option.code === countryCode && <CheckIcon />}
                </button>
              </li>
            )
          })}
        </ul>
      </section>
    )
  }

  const CountrySelect = () => {
    return (
      <div className={styles.countriesContainer}>
        <button
          className={styles.selected}
          onClick={toggleCountries}
          aria-label="View country list"
        >
          <Flag code={countryCode} />
          <p className={styles.dialCode}>{dialCode}</p>
          <DropdownIcon />
        </button>
        {showCountries && <Dropdown />}
      </div>
    )
  }

  const inputStyles = `
    ${styles.input}
    ${styles.phoneContainer}
    ${error ? styles.error : ""}
  `;

  const labelStyles = `
    ${styles.label}
    ${error ? styles.errorLabel : ""}
  `;

  return (
    <div className={styles.container}>
      <label className={labelStyles} htmlFor="phone">Phone Number</label>
      <div className={inputStyles}>
        <CountrySelect />
        <PhoneNumber
          value={value}
          onChange={onChange}
          error={error}
          errorMsg={errorMsg}
        />
      </div>
      {error && <p className={styles.errorMsg}>{errorMsg}</p>}
    </div>
  )
};